import Amount from "app/pages/.shared/Amount";
import { connect } from "react-redux";

const mapStateToProps = state => {
	return {
		currencyCode: state.partner.currencyCode,
		shop: state.shop,
	};
};

export default connect(mapStateToProps)(Amount);
